module.exports = __webpack_public_path__ + "static/media/help-black-icon.86ea7e67.svg";